import { SiteLink, PageSectionBackgroundColor } from '../../app-types'

/**
 * Picks the `LinkButton` color based on the section it sits in. Buttons
 * in a section-content row are ordered secondary → primary (the rightmost
 * button is the primary action). The colors below assume that pairing:
 *
 *   - white / light-gray bg → black outlined, green contained
 *   - black / purple / aqua bg → white outlined, green contained
 *   - orange / icons bg (the green surfaces) → black outlined, white contained
 *
 * An explicit `color` always wins. `undefined` means "use the theme
 * default" (which is `color="primary"` — green contained, black outlined).
 */
export function resolveAutoButtonColor({
  backgroundColor,
  variant,
  explicit,
}: {
  backgroundColor: PageSectionBackgroundColor | null
  variant: SiteLink['variant']
  explicit?: SiteLink['color']
}): SiteLink['color'] | undefined {
  if (explicit) return explicit

  const isOutlinedish = variant === 'outlined' || variant === 'text'

  switch (backgroundColor) {
    case 'white':
    case 'light-gray':
    case null:
      return undefined
    case 'black':
    case 'purple':
    case 'aqua':
      return isOutlinedish ? 'inverse' : undefined
    case 'orange':
    case 'icons':
      return isOutlinedish ? undefined : 'inverse'
    default:
      return undefined
  }
}
